import React, { FC } from 'react';
import { styled } from '@mui/material/styles';
import { Rectangle } from './SmallSquareButton.style';
import { CloseIcon } from '../../assets/CloseIcon';
import { ArrowLeftIcon } from '../../assets/ArrowLeftIcon';
import { MenuIcon } from '../../assets/MenuIcon';
import { VideoAppTheme } from '../../../api/models/venue';
import { theme } from '../../../theme';

export enum SmallSquareButtonType {
  Close,
  Hamburger,
  ArrowLeft,
}

interface SmallSquareButtonProps {
  onButtonClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  buttonType: SmallSquareButtonType;
  transparent?: boolean;
  color?: string;
  layoutTheme?: VideoAppTheme;
}

const StyledCloseIcon = styled(CloseIcon)<{ $layoutTheme?: VideoAppTheme }>(({ $layoutTheme }) => ({
  '& path': {
    fill: $layoutTheme === VideoAppTheme.Light ? 'var(--lightBlack)' : theme.palette.common.white,
  },
}));

export const SmallSquareButton: FC<SmallSquareButtonProps> = ({
  onButtonClick,
  buttonType,
  transparent,
  color,
  layoutTheme,
}) => {
  let icon;
  
  switch (buttonType) {
    case SmallSquareButtonType.Close:
      icon = <StyledCloseIcon $layoutTheme={layoutTheme} classes="" />;
      break;
    case SmallSquareButtonType.Hamburger:
      icon = <MenuIcon color={color} />;
      break;
    case SmallSquareButtonType.ArrowLeft:
      icon = <ArrowLeftIcon />;
      break;
  }
  
  return (
    <Rectangle $transparent={transparent} onClick={(e) => onButtonClick(e)}>
      {icon}
    </Rectangle>
  );
};
